import { handleSessionExpired } from '../utility/sessionExpired'

/**
 * `src/providers/api.js` hace las peticiones con `fetch` nativo (no axios),
 * así que el interceptor de axios no las cubre. Se envuelve `window.fetch`
 * una sola vez para detectar también ahí un 401 por token vencido/inválido.
 */
const nativeFetch = window.fetch.bind(window)

window.fetch = async (...args) => {
    const response = await nativeFetch(...args)

    if (response.status === 401 && sessionStorage.getItem('token')) {
        handleSessionExpired()
    }

    return response
}
